import { post } from "@/utils/utils";

const ad = {
  state: {
    adDetails: {}
  },
  mutations: {
    QUERY_AD_LIST() {},
    ADD_AD() {},
    EDIT_AD() {},
    DELETE_AD() {},
    QUERY_AD_TEMP_LIST() {},
    QUERY_AD_DETAILS(state, data) {
      state.adDetails = data;
    },
    QUERY_REPORT_DATA_SOURCE() {},
    QUERY_REPORT_DATA_REPORT_TYPE() {},
    INQUIRE_ABOUT_BENEFITS(){}
  },
  actions: {
    queryReportDataSource({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=ssr_datasource`,
        name: "QUERY_REPORT_DATA_SOURCE",
        params
      });
    },
    queryReportDataSource2({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=redpackage_badge_type`,
        name: "QUERY_REPORT_DATA_SOURCE2",
        params
      });
    },

    inquireAboutBenefits({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=redpackage_declare_prefix_type`,
        name: "INQUIRE_ABOUT_BENEFITS",
        params
      });
    },

    queryReportDataSource3({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=redpackage_badge_benefit_type`,
        name: "QUERY_REPORT_DATA_SOURCE3",
        params
      });
    },
    queryAdList({ commit }, params) {
      return post({
        commit,
        url: `/basic/layout/ad/list`,
        name: "QUERY_AD_LIST",
        params
      });
    },
    queryAdTempList({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=ad_template_type`,
        name: "QUERY_AD_TEMP_LIST",
        params
      });
    },
    addAd({ commit }, params) {
      return post({
        commit,
        url: `/basic/layout/ad/add`,
        name: "ADD_AD",
        params
      });
    },
    editAd({ commit }, params) {
      return post({
        commit,
        url: `/basic/layout/ad/edit`,
        name: "EDIT_AD",
        params
      });
    },
    deleteAd({ commit }, params) {
      return post({
        commit,
        url: `/basic/layout/ad/del`,
        name: "DELETE_AD",
        params
      });
    },
    queryReportDataReportType({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=ssr_report_type`,
        name: "QUERY_REPORT_DATA_REPORT_TYPE",
        params
      });
    }
  }
};

export default ad;
